'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

var _insertUnstyledNewline = require('../../customRichUtils/insertUnstyledNewline');

var _insertUnstyledNewline2 = _interopRequireDefault(_insertUnstyledNewline);

var _keyboardUtility = require('../../../../utils/keyboard/keyboardUtility');

var _richTextConstants = require('../../richText/richTextConstants');

var _draftjsConstants = require('../../draftjsConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Utils
var getNewStateOnReturn = function getNewStateOnReturn(event, editorState) {
    if ((0, _keyboardUtility.hasCommandModifier)(event)) return editorState;

    if ((0, _keyboardUtility.hasShiftKey)(event)) return _draftJs.RichUtils.insertSoftNewline(editorState);

    var newContentState = _draftJs.RichUtils.tryToRemoveBlockStyle(editorState);
    if (newContentState) return _draftJs.EditorState.push(editorState, newContentState, 'change-block-type');

    var currentBlockType = _draftJs.RichUtils.getCurrentBlockType(editorState);

    if (currentBlockType.indexOf(_richTextConstants.STYLE_COMMANDS.HEADING_PREFIX) !== -1 || currentBlockType === _richTextConstants.STYLE_COMMANDS.BLOCKQUOTE) {
        return (0, _insertUnstyledNewline2.default)(editorState);
    }

    return editorState;
}; // Lib

exports.default = function (event, _ref) {
    var getEditorState = _ref.getEditorState,
        setEditorState = _ref.setEditorState;

    var editorState = getEditorState();
    var newEditorState = getNewStateOnReturn(event, editorState);

    if (newEditorState !== editorState) {
        setEditorState(newEditorState);
        return _draftjsConstants.HANDLER_RETURN_VALUES.handled;
    }
    return _draftjsConstants.HANDLER_RETURN_VALUES.notHandled;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/editingHelper/handleReturn.js
// module id = 1731
// module chunks = 0